import React from "react";

const Mobile = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 mx-3">
      <h1 className="text-center">
        Email Signature Template Generator isn’t available on mobile yet. We
        hope you'll try it out on a larger screen
      </h1>
    </div>
  );
};

export default Mobile;
